import React from 'react';
import { SORTS } from '../utils/browseUtils';
import BrowseItem from './BrowseItem';

const BrowseListing = ({
  view,
  prefs,
  folderId,
  folderItems,
  docItems,
  dropTargetId,
  iconSize,
  copied,
  onToggleSort,
  onOpenItem,
  onOpenItemInNewTab,
  onOpenMenu,
  onDragOver,
  onDropFolder,
  onDragLeave,
}) => (
  <div
    className="docs-browse__body"
    onContextMenu={(e) => {
      onOpenMenu(e, { kind: 'blank', folderId });
    }}
  >
    {view === 'details' && (folderItems.length > 0 || docItems.length > 0) && (
      <div className="docs-browse__details-head" role="row">
        {SORTS.map((s) => (
          <button
            key={s.id}
            type="button"
            className={`docs-browse__col${prefs.sort === s.id ? ' is-sorted' : ''}`}
            onClick={() => onToggleSort(s.id)}
          >
            {s.label}
            {prefs.sort === s.id ? (prefs.dir === 'asc' ? ' ↑' : ' ↓') : ''}
          </button>
        ))}
      </div>
    )}

    {folderItems.length === 0 && docItems.length === 0 ? (
      <p
        className="docs-browse__empty"
        onContextMenu={(e) => onOpenMenu(e, { kind: 'blank', folderId })}
      >
        This folder is empty. Create a doc or a subfolder.
      </p>
    ) : (
      <>
        {folderItems.length > 0 && (
          <section className="docs-browse__section">
            <p className="docs-browse__section-label">Folders</p>
            <div className={`docs-browse__items docs-browse__items--${view}`}>
              {folderItems.map((item) => (
                <BrowseItem
                  key={`${item.kind}:${item.id}`}
                  item={item}
                  view={view}
                  iconSize={iconSize}
                  isDropTarget={dropTargetId === item.id}
                  copied={copied}
                  onOpen={onOpenItem}
                  onOpenInNewTab={onOpenItemInNewTab}
                  onContextMenu={onOpenMenu}
                  onDragOver={onDragOver}
                  onDragLeave={onDragLeave}
                  onDrop={onDropFolder}
                />
              ))}
            </div>
          </section>
        )}
        {docItems.length > 0 && (
          <section className="docs-browse__section">
            <p className="docs-browse__section-label">Documents</p>
            <div className={`docs-browse__items docs-browse__items--${view}`}>
              {docItems.map((item) => (
                <BrowseItem
                  key={`${item.kind}:${item.id}`}
                  item={item}
                  view={view}
                  iconSize={iconSize}
                  isDropTarget={dropTargetId === item.id}
                  copied={copied}
                  onOpen={onOpenItem}
                  onOpenInNewTab={onOpenItemInNewTab}
                  onContextMenu={onOpenMenu}
                  onDragOver={onDragOver}
                  onDragLeave={onDragLeave}
                  onDrop={onDropFolder}
                />
              ))}
            </div>
          </section>
        )}
      </>
    )}
  </div>
);

export default BrowseListing;
